module.exports = __webpack_public_path__ + "static/media/blueok.7cb1659f.svg";